import * as React from "react";
import {sendRequest} from "../../helpers/ajax";
import IListResults from "../../types/IListResults";
import IMessageHeaderSummary from "../../types/IMessageHeader";
import IMessageSearchRequest from "../../types/IMessageSearchRequest";
import IResponse from "../../types/IResponse";
import MessageList from "./MessageList";

interface IMessageListContainerState{
    loading: boolean;
}

class MessageListContainer extends React.Component<{}, IMessageListContainerState> {

    constructor(props: {}) {
        super(props);
        
        this.state = {loading: false};

        this.search = this.search.bind(this);
    }

    public render() {
        return(
            <MessageList loading={this.state.loading} search={this.search} />
        );
    }

    private async search (request: IMessageSearchRequest ) : Promise<IResponse<IListResults<IMessageHeaderSummary>>|null>{

        this.setState({loading: true});

        const response = await sendRequest<IResponse<IListResults<IMessageHeaderSummary>>>("/api/messages/search", "POST", request);

        this.setState({loading: false});

        return response;
    }

}

export default MessageListContainer;



// WEBPACK FOOTER //
// ./src/components/MessageList/MessageListContainer.tsx